package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.FileType
import com.jingfangpai.common.orm.mapping.enums.FileStatus
import com.jingfangpai.common.orm.mapping.enums.FileEntityType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class File(var id: String? = null){
	var url: String? = null
	var base64: String? = null
	var name: String? = null
	var type: FileType? = null
	var status: FileStatus? = null
	var entityType: FileEntityType? = null
	var entityId: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createOn: DateTime? = null
	@Serializable(with = DateTimeSerializer::class)
	var modifiedOn: DateTime? = null
	var trackingId: String? = null
	var description: String? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as File
		if (id != other.id) return false
		if (url != other.url) return false
		if (base64 != other.base64) return false
		if (name != other.name) return false
		if (type != other.type) return false
		if (status != other.status) return false
		if (entityType != other.entityType) return false
		if (entityId != other.entityId) return false
		if (createOn != other.createOn) return false
		if (modifiedOn != other.modifiedOn) return false
		if (trackingId != other.trackingId) return false
		if (description != other.description) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (url?.hashCode() ?: 0)
		result = 31 * result + (base64?.hashCode() ?: 0)
		result = 31 * result + (name?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (entityType?.hashCode() ?: 0)
		result = 31 * result + (entityId?.hashCode() ?: 0)
		result = 31 * result + (createOn?.hashCode() ?: 0)
		result = 31 * result + (modifiedOn?.hashCode() ?: 0)
		result = 31 * result + (trackingId?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		return result
	}

}
